import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { useCallback, useState } from "react";
import debounce from "lodash/debounce";
import { motion } from "framer-motion";

interface SearchBarProps {
  onSearch: (query: string) => void;
}

export const SearchBar = ({ onSearch }: SearchBarProps) => {
  const [searchValue, setSearchValue] = useState("");

  const debouncedSearch = useCallback(
    debounce((query: string) => {
      onSearch(query);
    }, 500),
    [onSearch]
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchValue(newValue);
    
    if (newValue === "") {
      onSearch("");
      return;
    }

    if (newValue.length >= 2) {
      debouncedSearch(newValue);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearch(searchValue);
    }
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative w-full max-w-2xl mx-auto px-2 sm:px-0"
    >
      <form onSubmit={handleSubmit} className="relative flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-600 w-4 h-4 sm:w-5 sm:h-5" />
          <Input
            type="text"
            value={searchValue}
            placeholder="ابحث عن الأدوات..."
            className="w-full pl-3 pr-9 sm:pl-4 sm:pr-10 py-2 text-sm sm:text-base bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border-gray-200 dark:border-gray-700 rounded-lg shadow-sm focus:ring-2 focus:ring-primary focus:border-transparent text-right font-arabic transition-all duration-300 hover:shadow-md"
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </div>
        <Button 
          type="submit"
          className="bg-primary hover:bg-primary/90 text-white text-sm sm:text-base px-3 sm:px-4"
        >
          بحث
        </Button>
      </form>
    </motion.div>
  );
};